export const HeaderTokens = {
  currentRoute: 'current-route',
};
